<template>
  <div class="index-map">
    <b-card v-if="$store.state.user && $store.state.user.userType == 1">
      <div>
        <b-row>
          <b-col md="8"></b-col>
          <b-col md="2">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :disabled="!polygonCompleted"
              @click="save"
              class="btn-block"
            >
              <feather-icon icon="CheckIcon" class="mr-50" />
              <span class="align-middle">Sačuvaj</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              :disabled="!polygonCompleted"
              @click="reset"
              class="btn-block"
            >
              <feather-icon icon="XIcon" class="mr-50" />
              <span class="align-middle">Poništi</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <gmap-map
      :center="center"
      :zoom="16"
      map-type-id="satellite"
      style="width: 100%"
      ref="map"
    >
    </gmap-map>
  </div>
</template>

<script>
import {
  BCardActions,
  BCard,
  BRow,
  BFormGroup,
  BCol,
  BForm,
  BButton,
  BAlert,
} from "bootstrap-vue";
import { mapState } from "vuex";
import store from "@/store";
import { gmapApi } from "vue2-google-maps";
import Ripple from "vue-ripple-directive";
import { heightFade } from "@core/directives/animations";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BAlert,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  mounted() {
    var $this = this;
    this.$refs.map.$mapPromise.then((map) => {
      $this.drawPathFromDB(map);
      $this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [],
        },
        polygonOptions: {
          fillColor: "red",
          fillOpacity: 0.15,
          strokeWeight: 2,
          strokeColor: "red",
          strokeOpacity: 0.8,
          clickable: false,
          editable: true,
          zIndex: 1,
        },
      });
      $this.drawingManager.setMap(map);

      google.maps.event.addListener(
        $this.drawingManager,
        "polygoncomplete",
        function (polygon) {
          $this.polygonRef = polygon;
          //SAVE PATH
          for (var i = 0; i < polygon.getPath().getLength(); i++) {
            var splittedUrlValue = polygon
              .getPath()
              .getAt(i)
              .toUrlValue(6)
              .split(",");
            $this.polygonPath[i] = {
              orderNumber: i,
              lat: Number(splittedUrlValue[0]),
              lng: Number(splittedUrlValue[1]),
            };
          }

          var clonedDrawingOptions = Object.assign(
            {},
            $this.drawingManager.drawingControlOptions
          );
          clonedDrawingOptions.drawingModes = [];
          $this.drawingManager.set(
            "drawingControlOptions",
            clonedDrawingOptions
          );
          $this.drawingManager.set("drawingMode");
          $this.polygonCompleted = true;
        }
      );
    });
  },
  data() {
    return {
      google: gmapApi,
      center: { lat: 43.82589159524827, lng: 17.310201722870158 },
      polygonCompleted: true,
      polygonRef: null,
      drawingManager: null,
    };
  },
  beforeDestroy() {
    store.commit("virtualFence/SET_PLYGON_PATH");
  },
  methods: {
    save() {
      var $this = this;
      store
        .dispatch("virtualFence/CREATE_VIRTUAL_FENCE")
        .then((response) => {
          $this.$swal({
            position: "bottom-end",
            icon: "success",
            title: "Virtuelna ograda je uspješno postavljena!",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {});
    },
    reset() {
      this.polygonRef.setMap(null);
      store.commit("virtualFence/SET_PLYGON_PATH");
      this.polygonCompleted = false;
      var clonedDrawingOptions = Object.assign(
        {},
        this.drawingManager.drawingControlOptions
      );
      clonedDrawingOptions.drawingModes = [
        google.maps.drawing.OverlayType.POLYGON,
      ];
      this.drawingManager.set("drawingControlOptions", clonedDrawingOptions);
      this.drawingManager.set(
        "drawingMode",
        google.maps.drawing.OverlayType.POLYGON
      );
    },
    drawPathFromDB(map) {
      this.polygonRef = new google.maps.Polygon({
        paths: this.polygonPath,
        fillColor: "red",
        fillOpacity: 0.15,
        strokeWeight: 2,
        strokeColor: "red",
        strokeOpacity: 0.8,
        clickable: false,
        editable: true,
        zIndex: 1,
      });
      this.polygonRef.setMap(map);
    },
  },
  computed: {
    ...mapState({
      polygonPath: (state) => state.virtualFence.polygonPath,
      latestDataForAllCattle: (state) => state.cattle.latestDataForAllCattle,
    }),
  },
};
</script>
<style lang="scss">
.index-map {
  .vue-map-container {
    height: 70vh !important;
  }
}
</style>
